<template>
    <v-card flat tile :to="`/auction-works/${work._id}`">
        <v-img :src="work?.imgs?.[0]?.url" :aspect-ratio="1 / 1" width="100%" :class="{ 'v-sheet--outlined': !work?.imgs?.[0]?.url }">
            <template #placeholder>
                <v-overlay absolute dark color="transparent">
                    <v-icon color="grey" size="40">mdi-image-broken</v-icon>
                </v-overlay>
            </template>
        </v-img>
        <v-card-title class="px-0 py-20">{{ work?.subject }}</v-card-title>
        <v-divider class="primary"/>
    </v-card>
</template>

<script>
export default {
    props: {
        work: { type: Object, default: () => ({}) },
    },
};
</script>


<style lang="scss" scoped>
.v-card__title {
    font-size: 24px;
    font-family: var(--font-notoserif);
}
@media (min-width: 768px) {
    .v-card__title {
        font-size: 18px;
    }
}
@media (min-width: 1024px) {
    .v-card__title {
        font-size: 24px;
    }
}
</style>